import { ExtranetTableColumnProps, ExtranetTableColumnRoot } from './ExtranetTableColumn'
import { joinClasses } from './joinClasses'

export const ExtranetTableGroupColumn = ({ children, ...props }: ExtranetTableColumnProps) => {
  return (
    <ExtranetTableColumnRoot
      style={{ flexDirection: 'column' }}
      className={joinClasses('entable__column entable__column--group', props.className)}
      flexGrow={props.size}
      {...props}
    >
      {children}
    </ExtranetTableColumnRoot>
  )
}
